import "./App.css";
import LoginScreen from "./screens/LoginScreen";
import { Routes, Route } from "react-router-dom";
import Home from "./screens/HomeScreen";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route path="/home" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
